export default __webpack_public_path__ + "static/media/icon-warning.c48c0f02.svg";